export const PRODUCT_PASSWORD_OPTION_KEY = 'password'
